// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './assets/lang/lang'
import VueLazyload from 'vue-lazyload'
// import 'element-ui/lib/theme-chalk/index.css';
// import {
//   Backtop,
//   Pagination
// } from 'element-ui';
Vue.config.productionTip = false

/* eslint-disable no-new */
// Vue.use(Backtop);
// Vue.use(Pagination);
Vue.use(VueLazyload)
new Vue({
  el: '#app',
  router,
  i18n,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js